import React from 'react';
import Slider from 'react-slick';

import kavakLogoSVG from '../assets/svg-logos/kavak.svg';
import theHomeDepotLogoSVG from '../assets/svg-logos/the-home-depot.svg';
import britishAmericanTobaccoLogoSVG from '../assets/svg-logos/british-american-tobacco.svg';
import renyPicotLogoSVG from '../assets/svg-logos/reny-picot.svg';
import cfeLogoSVG from '../assets/svg-logos/cfe.svg';
import imssLogoSVG from '../assets/svg-logos/imss.svg';
import shushiIttoLogoSVG from '../assets/svg-logos/sushi-itto.svg';

const LandingPageBrandsSlider = () => {
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 7,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 590,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    // The rule is disabled for this line because it's more simple
    // to handle prop forsending to the component.
    // This is the way.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Slider {...settings} className="landing-page-brands-slider">
      <div>
        <div className="slide-inner">
          <img src={kavakLogoSVG} className="align-center" alt="Kavak" />
        </div>
      </div>
      <div>
        <div className="slide-inner">
          <img src={theHomeDepotLogoSVG} className="home-depot align-center" alt="Home Depot" />
        </div>
      </div>
      <div>
        <div className="slide-inner">
          <img src={britishAmericanTobaccoLogoSVG} className="bta align-center" alt="British American Tobaco" />
        </div>
      </div>
      <div>
        <div className="slide-inner">
          <img src={renyPicotLogoSVG} className="align-center" alt="Reny Picot" />
        </div>
      </div>
      <div>
        <div className="slide-inner">
          <img src={cfeLogoSVG} className="align-center" alt="CFE" />
        </div>
      </div>
      <div>
        <div className="slide-inner">
          <img src={imssLogoSVG} className="imss align-center" alt="IMSS" />
        </div>
      </div>
      <div>
        <div className="slide-inner">
          <img src={shushiIttoLogoSVG} className="align-center" alt="Sushi Itto" />
        </div>
      </div>
    </Slider>
  );
};

export default LandingPageBrandsSlider;
